import "./SessionPageContent.css";
import React from "react";
import { observer } from "mobx-react";
import MobxPageContent from "shared/components/MobxPageContent";
import CookieConsent from "shared/components/CookieConsent";
import Propulator from "higher-order/Propulator";
import SessionPageLogo from "./SessionPageLogo";

@observer
class SessionPageContent extends React.Component {
    render() {
        const header = <SessionPageLogo baseAddress={this.props.session?.baseAddress} />;

        return (
            <MobxPageContent className={this.props.className} header={header} footer={<div />}>
                {this.props.children}
                <CookieConsent />
            </MobxPageContent>
        );
    }
}

export default Propulator(SessionPageContent, {
    sessionStore: ["session"]
});
